import { isEmpty, isNil } from 'lodash';

import { PageProductListingFilters } from 'src/data/Contentful/ContentfulGetPageProductListing.types';
import { getOr } from 'src/utils/getOr';

/**
 * Check if a specific filter is set on the PLP
 * @returns
 */
export const plpHasFilter = (filterName: string, filters: PageProductListingFilters = {}) => {
  const value = getOr(filters, filterName, null);
  return !isNil(value) && !isEmpty(value);
};
